.layout {
  background-color: var(--pgm-sys-color-surface);
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.layoutContent {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
}
